<app-accordion [elementId]="subSubSubGroup.id"
               [prefixId]=" prefixId"
               [isDeletable]="subSubSubGroup.deletable"
               [elementLabel]="subSubSubGroup._label"
               [isRepeatable]="subSubSubGroup._repeatable"
               [infoBulle]="subSubSubGroup.infoBulle"
               [groupType]="getGroupType(subSubSubGroup.id)"
               (addSomething)="addSubSubSubGroup()"
               (deleteSomething)="removeSubSubSubGroup()">
<p class="messageInfo">
  {{parcoursUtilisateur(subSubSubGroup)}}
                                            </p>
  <div *ngFor="let field of subSubSubGroup.fields; let i = index">
    <app-form-input [prefixId]="prefixId" [parentForm]="formGroup"
                    [field]="field" [subSectionId]="subSectionId"
                    [repeatablePath]="repeatablePath" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
                    [getRepeatablePathWithIndexForInput]="getRepeatablePathWithIndexForInput"
                    [noticeValue]="noticeValue" [groupOrSectionId]="subSubSubGroup.id" (newField)="newField($event)"
                    (deleteField)="deleteField($event)" [index]="index"></app-form-input>
  </div>
  <div *ngFor="let subSubSubSubGroup of subSubSubGroup.subSubSubSubGroup; let i = index">
    <app-sub-sub-sub-sub-group
      [hidden]="subSubSubSubGroup?.hidden"
      *ngIf="!subSubSubSubGroup?.hidden"
      [prefixId]="prefixId" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
      [formGroup]="formGroup"
      [subSubSubSubGroup]="subSubSubSubGroup"
      (newSubSubSubSubGroup)="newSubSubSubSubGroup($event)"
      (deleteSubSubSubSubGroup)="deleteSubSubSubSubGroup($event)"
      [repeatablePath]="repeatablePath" [subSectionId]="subSectionId"
      [repeatablePathWithIndex]="getRepeatablePathWithIndexForSubSubSubSubGroup(subSubSubSubGroup)"
      [noticeValue]="noticeValue"
      [linkForRouter]="linkForRouter" [index]="index">
    </app-sub-sub-sub-sub-group>
  </div>
</app-accordion>
